"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
require("../../common/style.scss");
var _urlUtils = require("../../common/utils/domain/urlUtils");
var _reportUtil = require("../../utils/reportUtil");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const _require = require('@tencent/cms-design-component'),
  ProductResource = _require.ProductResource;
const ROW_NUMBER = {
  // 一行多少个
  THREE: 3,
  TWO: 2
};
const formatProductResource = (properties, options = {}) => {
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString,
    formatUrlInText = _getFormatUrlMethods.formatUrlInText;
  const _properties$modTitle = properties.modTitle,
    modTitle = _properties$modTitle === void 0 ? '' : _properties$modTitle,
    _properties$desc = properties.desc,
    desc = _properties$desc === void 0 ? '' : _properties$desc,
    _properties$color = properties.color,
    color = _properties$color === void 0 ? '' : _properties$color,
    _properties$mergeComp = properties.mergeComponentStatus,
    mergeComponentStatus = _properties$mergeComp === void 0 ? false : _properties$mergeComp,
    _properties$paddingTo = properties.paddingTopNum,
    paddingTopNum = _properties$paddingTo === void 0 ? '' : _properties$paddingTo,
    _properties$paddingBo = properties.paddingBottomNum,
    paddingBottomNum = _properties$paddingBo === void 0 ? '' : _properties$paddingBo,
    _properties$cardData = properties.cardData,
    cardData = _properties$cardData === void 0 ? {} : _properties$cardData,
    _properties$videoData = properties.videoData,
    videoData = _properties$videoData === void 0 ? {} : _properties$videoData,
    _properties$txtData = properties.txtData,
    txtData = _properties$txtData === void 0 ? {} : _properties$txtData;
  const _ref = videoData || {},
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$configuration = _ref.configuration,
    videoDataList = _ref$configuration === void 0 ? [] : _ref$configuration;
  const _ref2 = cardData || {},
    _ref2$title = _ref2.title,
    cardTitle = _ref2$title === void 0 ? '' : _ref2$title,
    _ref2$rowspan = _ref2.rowspan,
    rowspan = _ref2$rowspan === void 0 ? false : _ref2$rowspan,
    _ref2$configuration = _ref2.configuration,
    cardDataList = _ref2$configuration === void 0 ? [] : _ref2$configuration;
  const _ref3 = txtData || {},
    _ref3$title = _ref3.title,
    textTitle = _ref3$title === void 0 ? '' : _ref3$title,
    _ref3$configuration = _ref3.configuration,
    txtDataList = _ref3$configuration === void 0 ? [] : _ref3$configuration;
  // 处理资源组件中视频教程部分数据解析
  const resultVideoList = videoDataList.map((videoItem, index) => {
    const value = _objectSpread({}, videoItem);
    value.img = value.type ? '' : value.img;
    value.type = value.type ? 'right' : 'center';
    value.extendProps = {
      'report-event': 'click_productResource_video',
      'report-ext1': index,
      'report-ext2': value.description || '',
      'report-ext3': value.videoPlayUrl || ''
    };
    value.postMessageUrl = (0, _urlUtils.getVideoIframeUrl)();
    return value;
  });
  const resultCardDataList = cardDataList.map((cardItem, index) => {
    const formattedHref = formatUrlString(cardItem.href || '');
    return _objectSpread(_objectSpread({}, cardItem), {}, {
      href: formattedHref,
      tabIndex: '',
      bindingNum: '',
      extendProps: {
        'report-event': 'click_productResource_card',
        'report-ext1': index,
        'report-ext2': cardItem.title || '',
        'report-ext3': formattedHref
      }
    });
  });
  const resultTxtDataList = txtDataList.map((item, index) => {
    const _item$head = item.head,
      head = _item$head === void 0 ? '' : _item$head,
      _item$title = item.title,
      title = _item$title === void 0 ? '' : _item$title,
      _item$description = item.description,
      description = _item$description === void 0 ? '' : _item$description;
    const formatContent = formatUrlInText(description, {
      reportEvent: 'click_productResource_txt_richtext_href'
    });
    return {
      head,
      title,
      description: formatContent
    };
  });
  return {
    modTitle,
    desc: formatUrlInText(desc),
    cardData: {
      title: cardTitle,
      rowspan: rowspan ? ROW_NUMBER.TWO : ROW_NUMBER.THREE,
      configuration: resultCardDataList
    },
    videoData: {
      title,
      configuration: resultVideoList
    },
    txtData: {
      title: textTitle,
      configuration: resultTxtDataList
    },
    bgColor: color,
    mergeComponentStatus,
    paddingTopNum,
    paddingBottomNum
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatProductResourc = formatProductResource(data, {
        domains
      }),
      modTitle = _formatProductResourc.modTitle,
      desc = _formatProductResourc.desc,
      cardData = _formatProductResourc.cardData,
      videoData = _formatProductResourc.videoData,
      txtData = _formatProductResourc.txtData,
      bgColor = _formatProductResourc.bgColor,
      mergeComponentStatus = _formatProductResourc.mergeComponentStatus,
      paddingTopNum = _formatProductResourc.paddingTopNum,
      paddingBottomNum = _formatProductResourc.paddingBottomNum;
    const bgStyle = bgColor ? (0, _componentUtils.doComponentsBgColorEvent)(bgColor) : {}; // 处理组件背景色
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_productResource', componentKey, modTitle])), /*#__PURE__*/React.createElement(ProductResource, {
      flexTitle: modTitle,
      desc: desc,
      cardData: cardData,
      videoData: videoData,
      txtData: txtData,
      style: bgStyle,
      mergeComponentStatus: mergeComponentStatus,
      paddingTopNum: paddingTopNum,
      paddingBottomNum: paddingBottomNum,
      onClick: (tabIndex, cid) => {
        window.childClickToTab(tabIndex, cid);
      }
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}